var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.977,
    height: 17.977,
    viewBox: "0 0 17.977 17.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_5",
    "data-name": "Layer 5",
    d: "M3,18V13.76a1,1,0,0,1,.29-.71l2.35-2.34h0l7-7h0L14.45,1.9a3,3,0,0,1,4.24,0L20.1,3.31a3,3,0,0,1,0,4.24L9,18.71a1,1,0,0,1-.71.29H4A1,1,0,0,1,3,18Zm4.78-6.61,2.83,2.83,5.58-5.58L13.36,5.81ZM15.9,3.27,14.78,4.39l2.83,2.83L18.73,6.1a1,1,0,0,0,0-1.41L17.31,3.27A1,1,0,0,0,15.9,3.27ZM5,17H7.83l1.36-1.36L6.36,12.81,5,14.17Z",
    transform: "translate(-3 -1.023)",
    fill: "#c0c7cc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.dfc0b753b380267fba8238db49a53e70.svg";
export { ForwardRef as ReactComponent };